import { normalizeTextString } from './normalizeTextString';
import { calculatePrefixPath } from './rendered-page-creation/calculate-prefixed-path';

// Helper function to extract locale from different structures
const getLocale = (link: any): string => {
  return link?.sys?.locale?.toLowerCase() || link?.node_locale?.toLowerCase();
};

export const generateCorrectSlug = (
  link: any,
  prefix: string,
  urlSubdirectory?: string | null,
): string => {
  const locale = getLocale(link);
  // If customizedSlug is provided, use it as-is (don't add subdirectory prefix)
  if (link?.customizedSlug) {
    return calculatePrefixPath(link?.customizedSlug, prefix);
  }

  // Build the base path with locale
  const localePath = calculatePrefixPath(`/${locale}`, prefix);
  const normalizedSlug = normalizeTextString(link?.slug, true);

  // Add URL subdirectory prefix if provided
  if (urlSubdirectory || link?.urlSubDirectory) {
    return `${localePath}/${urlSubdirectory ?? link?.urlSubDirectory}/${normalizedSlug}`;
  }

  return `${localePath}/${normalizedSlug}`;
};

export const generateCorrectSlugForPage = (
  page: {
    slug: string;
    customizedSlug: string;
    node_locale: string;
  },
  prefix: string,
  urlSubDirectory: string | null,
): string => {
  // If customizedSlug is provided, use it as-is (don't add subdirectory prefix)
  if (page?.customizedSlug) {
    return calculatePrefixPath(page?.customizedSlug, prefix);
  }

  // Build the base path with locale
  const localePath = calculatePrefixPath(`/${page.node_locale}`, prefix);
  const normalizedSlug = normalizeTextString(page?.slug, true);

  // Add URL subdirectory prefix if provided
  if (urlSubDirectory) {
    return `${localePath}/${urlSubDirectory}/${normalizedSlug}`;
  }

  return `${localePath}/${normalizedSlug}`;
};

export const generateSlugForPage = (
  page: {
    slug: string;
    sys: { locale: string };
  },
  prefix: string,
  urlSubDirectory: string | null,
): string => {
  const pagePrefixAndLocale = calculatePrefixPath(
    `/${page?.sys?.locale?.toLocaleLowerCase()}`,
    prefix,
  );

  const normalizedSlug = normalizeTextString(page?.slug, true);

  // Add URL subdirectory prefix if provided
  if (urlSubDirectory) {
    return `${pagePrefixAndLocale}/${urlSubDirectory}/${normalizedSlug}`;
  }

  return `${pagePrefixAndLocale}/${normalizedSlug}`;
};
